module.exports = __webpack_public_path__ + "static/GminaZblewo-c9bc5265c35cb8ef69b4509daf0b91bb.svg";